import "slick-carousel/slick/slick";

if(jQuery('.prize-select-slider__slider').length >= 1) {
    jQuery(".prize-select-slider__slider").on('init', function(event, slick){
        if(jQuery(".prize-select-slider__slider .slick-slide:not(.slick-cloned)").length <= 1){
            jQuery(".news-teaser-sec .slick-arrow").addClass("hidden");
        }
    });

    jQuery(document).ready(function () {
        jQuery(".prize-select-slider__slider").slick({
            slidesToShow: 1,
            prevArrow: jQuery(".prize-select-slider__prev"),
            nextArrow: jQuery(".prize-select-slider__next"),
            dots: false,
            infinite: false,
            speed: 400,
            mobileFirst: true,
            responsive: [
                {
                    breakpoint: 767,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2,
                    }
                },
                {
                    breakpoint: 991,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 3,
                    }
                },
            ]
        });

        // AJAX Post Call

        jQuery('.prize-select-slider .prize-select-slider__slider-slide .prize-select-slider__slider-slide-btn').on('click', function(e) {
            e.preventDefault();

            let wst = jQuery(this).data('wst');
            let pid = jQuery(this).data('pid');
            let modal = jQuery('.singing-rockstar-overlay');
            let spinner = jQuery('#singing-cans-loader');
            let slider = jQuery('.prize-select-slider');

            spinner.show();
            slider.addClass('non-selectable');

            jQuery.ajax({
                url: '/singende-dosen/losing',
                method: 'POST',
                data: {
                    wst,
                    pid
                },
                success: function(response) {
                    let url = modal.data(`tnb-data-${pid}-url`);
                    let urlText = modal.data(`tnb-data-${pid}-url-text`);
        
                    modal.find('.tnb-btn').attr('href', url).find('span').text(urlText);
        
                    modal.addClass('active');
                },
                error: function(xhr, status, error) {

                },
                complete: function() {
                    spinner.hide();
                    slider.removeClass('non-selectable');
                }
            });
        });

        // If form submitted scroll to

        if(jQuery('body').hasClass('singing-cans-normal-submitted')) {
            let sliderOffset = jQuery('.prize-select-slider').offset().top;

            jQuery('html, body').animate({ scrollTop: sliderOffset }, 'slow');
        }
    });
}
